module.exports = __webpack_public_path__ + "img/f38.15fdb5e0.jpg";